import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, SearchCheck } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const NETWORK_LINKS = [
  ["instagram", "Instagram"], ["tiktok", "TikTok"], ["facebook", "Facebook"], ["youtube", "YouTube"],
  ["twitter", "X (Twitter)"], ["snapchat", "Snapchat"], ["telegram", "Telegram"],
  ["linkedin", "LinkedIn"], ["twitch", "Twitch"], ["threads", "Threads"], ["discord", "Discord"],
  ["soundcloud", "SoundCloud"], ["whatsapp", "WhatsApp"], ["kick", "Kick"], ["spotify", "Spotify"], ["trafic-web", "Trafic Web SEO"],
];

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-white/10 mt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 font-heading text-xl font-bold mb-4">
            <img src="/nav-icon-80.png" alt="Buy Likes and Followers" className="w-9 h-9 object-contain" width="36" height="36" loading="lazy" decoding="async" />
            <span className="text-gradient">Buy Likes and Followers</span>
          </div>
          <p className="text-sm text-zinc-500 max-w-xs">{t("footer.brand_description", "Followers, likes, vues et engagement réel pour 12 réseaux sociaux. Livraison rapide, support dédié.")}</p>
          <div className="flex gap-3 mt-5 text-zinc-500">
            <Instagram className="w-4 h-4" /><Facebook className="w-4 h-4" /><Youtube className="w-4 h-4" /><Twitter className="w-4 h-4" />
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-heading text-sm font-semibold text-white mb-4">{t("footer.services", "Nos services")}</h4>
          <div className="grid grid-cols-2 gap-2">
            {NETWORK_LINKS.map(([slug, name]) => (
              <Link key={slug} to={`/reseaux/${slug}`} className="text-sm text-zinc-500 hover:text-white transition-colors" data-testid={`footer-network-link-${slug}`}>
                Followers {name}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-white mb-4">{t("footer.resources", "Ressources")}</h4>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/blog" className="hover:text-white transition-colors">{t("blog.title", "Blog & Guides")}</Link></li>
            <li><Link to="/devenir-influenceur" className="hover:text-white transition-colors font-semibold" data-testid="footer-pillar-link">{t("footer.become_influencer", "Devenir influenceur")}</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">{t("faq.title", "FAQ")}</Link></li>
            <li><Link to="/suivi-commande" className="hover:text-white transition-colors">{t("tracking.title", "Suivi de commande")}</Link></li>
            <li><Link to="/acheter-followers" className="hover:text-white transition-colors">{t("footer.buy_followers_link", "Acheter des Followers")}</Link></li>
            <li><Link to="/acheter-likes-instagram" className="hover:text-white transition-colors">{t("footer.buy_likes_link", "Acheter des Likes Instagram")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-white mb-4">{t("footer.legal", "Mentions légales")}</h4>
          <ul className="space-y-2 text-sm text-zinc-500 mb-6">
            <li><Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-legal-notice-link">{t("footer.legal_notice", "Mentions légales")}</Link></li>

            <li><Link to="/cgv" className="hover:text-white transition-colors" data-testid="footer-cgv-link">{t("footer.cgv", "CGV")}</Link></li>
            <li><Link to="/politique-de-confidentialite" className="hover:text-white transition-colors" data-testid="footer-privacy-link">{t("footer.privacy", "Politique de confidentialité")}</Link></li>
          </ul>
          <h4 className="font-heading text-sm font-semibold text-white mb-4">{t("footer.support", "Support")}</h4>
          <ul className="space-y-2 text-sm text-zinc-500">
            <li><Link to="/contact" className="hover:text-white transition-colors font-semibold" data-testid="footer-contact-link">{t("footer.contact", "Contactez-nous")}</Link></li>
            <li>support@buylikesandfollowers.com</li>
            <li>{t("footer.support_availability", "Disponible 7j/7")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-center gap-3 text-center text-xs text-zinc-600">
        <span>© {new Date().getFullYear()} Buy Likes and Followers — {t("footer.rights", "Tous droits réservés.")}</span>
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-zinc-400" data-testid="google-verified-badge">
          <SearchCheck className="w-3.5 h-3.5 text-emerald-400" /> {t("footer.google_verified", "Propriété vérifiée par Google")}
        </span>
      </div>
    </footer>
  );
}
